var _a;
import { bytes, bibytes } from "./bytes";
import { bitRates, byteRates } from "./byteRates";
import { times } from "./times";
import { UnitType } from "./interface";
export var UNIT_MAP = (_a = {},
    _a[UnitType.Time] = times,
    _a[UnitType.Byte] = bytes,
    _a[UnitType.Bibyte] = bibytes,
    _a[UnitType.BitRate] = bitRates,
    _a[UnitType.ByteRate] = byteRates,
    _a);
//# sourceMappingURL=unitMap.js.map